import ContentLoader from 'react-content-loader';

const DemoCardsLoader = ( props ) => (
	<ContentLoader
		speed={ 2 }
		width={ 360 }
		height={ 266 }
		viewBox="0 0 360 266"
		backgroundColor="#f3f3f3"
		foregroundColor="#ecebeb"
		{ ...props }
	>
		<rect x="1" y="223" rx="3" ry="3" width="355" height="6" />
		<rect x="1" y="239" rx="3" ry="3" width="355" height="6" />
		<rect x="1" y="255" rx="3" ry="3" width="178" height="6" />
		<rect x="1" y="1" rx="8" ry="8" width="355" height="168" />
		<rect x="1" y="189" rx="3" ry="3" width="170" height="14" />
	</ContentLoader>
);

export default DemoCardsLoader;
